/**
 * Chuỗi của nhóm màn `van-hanh` (Tổng quan, Nhật ký truy vết, Thử nghiệm) thuộc module `tro-ly-ai` — tạm tách tệp khi
 * dựng song song, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `troLyAiVanHanh`; sâu tối đa hai cấp dưới nó.
 */
export const viVanHanh = {
  troLyAiVanHanhTongQuan: {
    tieuDe: 'Tổng quan Trợ lý AI',
    mo: 'Hoạt động hỏi đáp trong {{n}} ngày gần nhất.',
    xuHuong: 'Xu hướng hỏi',
    xuHuongMo: 'Số lượt hỏi mỗi ngày. Ngày không có lượt hỏi vẫn được hiển thị để thấy rõ khoảng trống.',
    xuHuongGioMo: 'Tổng lượt hỏi theo từng khung giờ trong {{n}} ngày (giờ Việt Nam) — cho thấy giờ cao điểm.',
    theoNgay: 'Theo ngày',
    theoGio: 'Theo giờ',
    cheDoXuHuong: 'Xem xu hướng theo',
    chuaCoLuot: 'Chưa có lượt hỏi nào trong kỳ.',
    cauThuongGap: 'Câu hỏi thường gặp',
    cauThuongGapMo: 'Các cách hỏi giống nhau đã được gom về một dòng.',
    chuaCoCau: 'Chưa có câu hỏi nào được ghi lại.',
    goiYNgay: '{{ngay}} · {{n}} lượt',
    goiYGio: '{{tu}}h–{{den}}h · {{n}} lượt',
    nhanGio: '{{gio}}h',
    thu0: 'CN',
    thu1: 'T2',
    thu2: 'T3',
    thu3: 'T4',
    thu4: 'T5',
    thu5: 'T6',
    thu6: 'T7',
  },
  troLyAiVanHanhSuDung: {
    chuaLayDuoc: 'Chưa lấy được số liệu sử dụng. Thử tải lại trang.',
    luotHoi: 'Lượt hỏi',
    trongKy: 'Trong {{n}} ngày gần nhất',
    traLoiDuoc: 'Trả lời được',
    tyLe: '{{p}} tổng số lượt hỏi',
    biTuChoi: 'Bị từ chối',
    biTuChoiMo: 'Ngoài phạm vi được phép hỏi',
    gapLoi: 'Gặp lỗi',
    khongCoLoi: 'Không có lượt nào lỗi',
    gapLoiMo: 'Lượt đọc dữ liệu bị lỗi, chưa trả lời được',
    tocDo: 'Tốc độ trả lời',
    thuong: 'Thường',
    chamNhat: 'Chậm nhất',
    tocDoMo: 'Thời gian lấy dữ liệu để trả lời. Chưa tính thời gian trợ lý soạn câu trả lời.',
    ms: '{{so}} ms',
    giay: '{{so}} giây',
    theoNguon: 'Nguồn dữ liệu được hỏi',
    theoNguonMo: 'Người dùng đang hỏi nhiều nhất về nguồn nào.',
    chuaTraLoiDuoc: '{{n}} chưa trả lời được',
    chuaCoNguon: 'Chưa có nguồn nào được hỏi trong kỳ.',
    theoVai: 'Ai đang hỏi',
    theoVaiMo: 'Số lượt hỏi theo vai trò người dùng.',
    chuaCoVai: 'Chưa có người dùng nào đặt câu hỏi trong kỳ.',
    hoiThoaiDaLuu: 'Trò chuyện đã lưu',
    hoiThoaiMo: 'Lượt hỏi trong kỳ, tách theo Hỏi đáp AI và từng chatbot.',
    troLyAi: 'Trợ lý AI',
    chatbot: 'Chatbot',
    doanLuot: '{{doan}} cuộc · {{luot}} lượt',
    chuaCoDoan: 'Chưa có cuộc trò chuyện nào.',
  },
  troLyAiVanHanhNhatKy: {
    tieuDe: 'Nhật ký truy vết',
    phuDe:
      'Ghi lại mọi chu kỳ đồng bộ và mọi câu SQL đã qua lớp kiểm soát truy vấn, kể cả những câu bị từ chối — nơi tra cứu khi cần biết vì sao trợ lý không trả lời được một câu hỏi.',
    taiLai: 'Tải lại',
    tabCauHoi: 'Câu hỏi & SQL ({{n}})',
    tabDongBo: 'Chu kỳ đồng bộ ({{n}})',
    tabTroChuyen: 'Lịch sử trò chuyện',
    colLuc: 'Lúc',
    colBang: 'Bảng',
    colKetQua: 'Kết quả',
    colDong: 'Dòng',
    colGhiChu: 'Ghi chú',
    colCauHoi: 'Câu hỏi',
    colChiTiet: 'Câu lệnh / lý do từ chối',
    chepDayDu: 'đồng bộ toàn bộ',
    chepTiep: 'đồng bộ tăng dần',
    boQua: 'bỏ qua',
    dungLai: 'dừng giữa chừng',
    biTuChoi: 'bị từ chối',
    chayHong: 'lỗi khi chạy',
    soDong: '{{n}} dòng',
    chayTrucTiep: '— chạy trực tiếp —',
    cauLenhTrucTiep: 'Câu lệnh chạy trực tiếp',
    docGhi: 'đọc {{doc}} · ghi {{ghi}}',
    xoaThem: ' · xoá {{n}}',
    giayNgan: '{{so}} giây',
    rongCauHoi: 'Chưa có lượt nào. Hỏi một câu ở màn Hỏi đáp AI rồi quay lại.',
    rongDongBo: 'Chưa có chu kỳ nào được ghi. Bấm Đồng bộ ở màn Kết nối nguồn.',
    congTuChoi: 'Lý do từ chối',
    cauLenh: 'Câu lệnh',
    bangDaDoc: 'Bảng đã đọc',
    tieuDeCauHoi: 'Câu hỏi & SQL đã chạy',
    tieuDeDongBo: 'Chu kỳ đồng bộ',
    xemLuot: 'Xem chi tiết lượt',
    xemLuotCua: 'Xem chi tiết lượt lúc {{luc}}',
    chiTietMo: '{{luc}} · {{nguon}}',
    chiTietMs: ' · {{ms}} ms',
    locTatCa: 'Tất cả',
    timTroChuyen: 'Tìm theo tên hoặc nội dung cuộc trò chuyện...',
    loaiTroLy: 'Trợ lý AI',
    loaiChatbot: 'Chatbot',
    locLoai: 'Loại cuộc trò chuyện',
    khoangNgay: 'Khoảng thời gian',
    trongNgay: '{{n}} ngày qua',
    soLuot: '{{n}} tin nhắn',
    doanChuaDatTen: '(chưa có tên)',
    khachNhung: 'Khách (khung nhúng)',
    xemCauLenh: 'Xem câu lệnh đã chạy',
    maTraCuu: 'Mã tra cứu chuỗi xử lý',
    chepMa: 'Chép mã tra cứu',
    daChepMa: 'Đã chép mã tra cứu.',
    moTuNhatKy: 'Mở từ Nhật ký thao tác',
    chonDoan: 'Chọn một cuộc trò chuyện',
    chonDoanMo: 'Nội dung đầy đủ — câu hỏi, câu trả lời và câu lệnh đã chạy — hiện ở đây.',
    moDoan: '{{nhan}} · {{vai}} · bắt đầu {{luc}}',
    rongTroChuyen: 'Không có cuộc trò chuyện nào',
    rongTroChuyenKhongLoc: 'Chưa có cuộc trò chuyện nào được lưu trong kỳ.',
    chiQuanTri: 'Chỉ quản trị xem được lịch sử trò chuyện',
    chiQuanTriMo: 'Lịch sử của mọi vai trò có thể chứa dữ liệu mà vai trò của bạn không được xem.',
    danhSachDoan: 'Danh sách cuộc trò chuyện',
  },
  troLyAiVanHanhDem: {
    tieuDe: 'Bộ nhớ đệm câu trả lời',
    moTa: 'Câu hỏi trùng hoàn toàn với câu đã hỏi được trả lời ngay từ bộ nhớ đệm, không tính lại.',
    bat: 'Bật bộ nhớ đệm',
    sucChua: 'Dung lượng tối đa (số lượt)',
    khoang: 'Trong khoảng {{thap}}–{{cao}}',
    luu: 'Lưu cấu hình đệm',
    daLuu: 'Đã lưu cấu hình bộ nhớ đệm.',
    khongTaiDuoc: 'Không đọc được cấu hình bộ nhớ đệm',
    daKep: 'Máy chủ đã điều chỉnh giá trị cho phù hợp giới hạn — ô nhập hiện giá trị máy chủ đã nhận.',
    soMuc: 'Đang lưu: {{n}} lượt',
    tiLeTrung: 'Tỉ lệ dùng lại (cache hit): {{p}}%',
    nguonEnv:
      'Chưa cấu hình Redis cho Trợ lý AI — cấu hình đang lấy từ biến môi trường và chỉnh ở đây sẽ không có tác dụng.',
    hanPhut: 'Thời gian lưu câu trả lời (phút)',
    khoangPhut: '{{thap}}–{{cao}} phút',
    demTrucTiep: 'Áp dụng cả cho nguồn đọc trực tiếp',
    demTrucTiepMo:
      'Mặc định tắt — câu trả lời của nguồn đọc trực tiếp luôn phản ánh dữ liệu tại thời điểm hỏi. Chỉ bật khi CSDL thay đổi vài lần mỗi ngày.',
    sqlHanPhut: 'Thời gian lưu câu lệnh (phút)',
    sqlTat:
      '0 = tắt. Khi câu trả lời hết thời gian lưu, hệ thống dùng lại câu lệnh cũ và chạy lại để lấy số liệu mới — bỏ qua được bước sinh SQL.',
    tiengHanPhut: 'Thời gian lưu giọng đọc (phút)',
    tiengTat:
      '0 = không lưu đệm lượt có giọng đọc. Nên ngắn hơn thời gian lưu câu trả lời vì mỗi lượt có giọng đọc chiếm dung lượng gấp khoảng hai mươi lần.',
    tiengCanRedis: 'Cần Redis — nếu không có, lượt có giọng đọc không được lưu đệm dù đặt giá trị nào.',
    demTieng: 'Lưu đệm giọng đọc: {{gt}}',
    co: 'có',
    khong: 'không',
    cheDoRedis: 'Bộ nhớ dùng chung (Redis)',
    cheDoTienTrinh: 'Bộ nhớ trong tiến trình',
  },
  troLyAiVanHanhThuNghiem: {
    tieuDe: 'Thử nghiệm',
    phuDe: 'Kiểm tra riêng hai việc: mô hình nhận được ngữ cảnh gì, và một câu lệnh SQL có được phép chạy hay không.',
    chonNguon: 'Nguồn dữ liệu để thử',
    loiNguonTieuDe: 'Không đọc được danh sách nguồn',
    loiNguonGoiY:
      'Nếu bạn đăng nhập trước lần cấp quyền gần nhất thì phiên đăng nhập chưa nhận quyền mới — hãy đăng xuất rồi đăng nhập lại.',
    chuaCoNguonSanSang: 'Chưa có nguồn nào sẵn sàng. Kết nối một nguồn ở màn Kết nối nguồn rồi quay lại.',
    sangKetNoi: 'Sang Kết nối nguồn',
    tabCauLenh: 'Câu lệnh',
    tabNguCanh: 'Gói ngữ cảnh',
    cauHoiTuyChon: 'Câu hỏi (tuỳ chọn — chỉ để ghi vào nhật ký)',
    viDuCauHoi: 'VD: Tháng trước thất thoát bao nhiêu?',
    cauLenhSql: 'Câu lệnh SQL',
    chayQuaCong: 'Kiểm tra và chạy',
    tranDong: '{{dialect}} · giới hạn {{n}} dòng',
    cauMauDaLuu: 'Câu mẫu đã lưu — bấm để nạp',
    congTuChoi: 'Câu lệnh bị từ chối',
    cauDaVietLai: 'Câu lệnh thực tế đã chạy — lớp kiểm soát truy vấn đã điều chỉnh',
    soDong: '{{n}} dòng',
    daCatTran: 'đã cắt theo giới hạn dòng',
    soLieuTrucTiep: 'số liệu trực tiếp',
    duLieuToi: 'dữ liệu cập nhật đến {{luc}}',
    hien100: 'Hiện 100 dòng đầu trong {{n}}.',
    ketQuaHienODay:
      'Kết quả sẽ hiển thị tại đây, kèm câu lệnh thực tế đã chạy nếu lớp kiểm soát truy vấn có điều chỉnh.',
    bangKetQua: 'Kết quả câu lệnh',
    cauHoiCatNguCanh: 'Câu hỏi (tuỳ chọn — ngữ cảnh sẽ được rút gọn theo câu này)',
    deTrongXemToanBo: 'Để trống để xem toàn bộ gói',
    soBang: '{{n}} bảng',
    soLuat: '{{n}} quy tắc bắt buộc',
    soThuatNgu: '{{n}} thuật ngữ',
    soCauMau: '{{n}} câu mẫu',
    soKyTu: '{{n}} ký tự',
    noiDungGoi: 'Nội dung gói ngữ cảnh',
    ketQua: 'Kết quả',
    tomTatGoi: 'Tóm tắt gói',
    luuLamMau: 'Lưu làm câu mẫu',
    daLuuMau: 'Đã lưu câu mẫu — trợ lý sẽ tham khảo câu này khi trả lời các câu hỏi tương tự.',
    mauCanCauHoi: 'Điền ô Câu hỏi để lưu được câu mẫu',
  },
} as const;
